import { render, staticRenderFns } from "./editProduct.vue?vue&type=template&id=3a2023fd"
import script from "./editProduct.vue?vue&type=script&lang=js"
export * from "./editProduct.vue?vue&type=script&lang=js"
import style0 from "./editProduct.vue?vue&type=style&index=0&id=3a2023fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports